import React, { useEffect, useState } from "react";
import TableFixedPage from "../../TableFixedPage/TableFixedPage";
import { getFailedPayListApi } from "../../../Api/PanelAdminServices";
import FailedPayTabel from "../../Tables/PayReq/FailedPayTabel/PayedReqTabel";
import { errorToast } from "../../../Utils/Toast/Toast";

const FailedPayContainer = () => {
  const [datalistState, setDataListState] = useState();
  useEffect(() => {
    getdataHandler();
  }, []);
  const getdataHandler = () => {
    getFailedPayListApi((succ, res) => {
      if (succ) {
        if (res.status === 1) {
          const mergedArray = [
            ...res.transaction?.deliver.map((item, index) => ({
              ...item,
              type: "deliver",
              userId: item.deliver_id,
              Key: parseInt(`${item.order_id}${index}`),
            })),
            ...res.transaction?.supplier.map((item, index) => ({
              ...item,
              type: "supplier",
              userId: item.supplier_id,
              Key: parseInt(`${item.order_id}${index}`),
            })),
          ];
          setDataListState(mergedArray);
        } else {
          errorToast(res.message);
        }
      } else {
        console.error(res);
      }
    });
  };

  return (
    <section className="w-100 d-flex align-items-center flex-column">
      <TableFixedPage title={"پرداختی های ناموفق"} />
      <FailedPayTabel data={datalistState} updateList={getdataHandler} />
    </section>
  );
};

export default FailedPayContainer;
